import { Component, Vue, Prop } from 'vue-property-decorator'
import { INewsArticle } from '@/store/modules/game/interfaces'

@Component
export default class NewsPanel extends Vue {
  @Prop() article: INewsArticle

  private runAction(action: string | undefined) {
    if (action) {
      switch(action) {
        case 'goto:account': return this.$router.push('account')
        case 'goto:tutorial': {
          this.$store.dispatch('SET_CLASSIC', true)
          return this.$router.push({path: '/lobby?mode=tutorial'})
        }
        case 'goto:howtoplay': return window.open('https://www.quickpicks.com/playing/','_blank')
      }
    }
  }

  private render(h: any): any {
    let image: JSX.Element | null = null
    if (this.article.image) {
      image = (<img src={this.article.image}></img>)
    }

    let action: JSX.Element | null = null
    if (this.article.action) {
      action = (<span></span>)
    }

    const styletag = this.article.action === 'goto:tutorial' ? 'tutorial' : ''

    return (
      <div class={this.article.action ? `news-card action ${styletag}` : `news-card ${styletag}`} onClick={this.runAction.bind(this, this.article.action)}>
        {image}
        <div class='news-card-inner'>
          <h1>{this.article.title}</h1>
          <p domPropsInnerHTML={this.article.body}></p>
          {action}
        </div>
      </div>
    );
  }
}
